import {ThemeProvider} from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import MainPage from './pages/mainPage.tsx'
import {Box, useMediaQuery, useTheme} from "@mui/material";
import {MobileOnlyWidget} from './widgets/MobileOnlyWidget.tsx';
import {useAppInitialization} from "./entities/hooks/useAppInitialization.ts";
import {AppLoader} from './widgets/AppLoader.tsx';
import {GradientBackground} from "react-gradient-animation";
import {useMemo} from "react";
import {useAppSelector} from "./app/store/hooks.ts";




function App() {
    const muiTheme = useTheme()
    const isWideScreen = useMediaQuery(muiTheme.breakpoints.up('md'))
    const {safeArea, theme, isInitilizing} = useAppInitialization();
    const colors = useAppSelector((state) => state.app.colors)



    const content = useMemo(() => {
        if (isWideScreen) {
            return <MobileOnlyWidget/>
        }
        if (isInitilizing) {
            return <AppLoader />
        }
        return <MainPage/>
    }, [isInitilizing, isWideScreen]);



    return (
        <ThemeProvider theme={theme}>
            <CssBaseline/>
            <Box sx={{width: '100vw', height: '100dvh', position: 'relative', padding: `${safeArea.top}px  0 0 0`, overflowY: 'hidden'}}>
                <GradientBackground
                    count={20}
                    size={{min: 400, max: 700, pulse: 0.3}}
                    speed={{x: {min: 0.4, max: 1.6}, y: {min: 0.4, max: 1.6}}}
                    colors={{
                        background: "#1e1e1e",
                        particles: colors,
                    }}
                    blending="overlay"
                    opacity={{center: 0.5, edge: 0}}
                    skew={0}
                    shapes={["c"]}
                    style={{opacity: 0.8}}
                />
                {content}
            </Box>
        </ThemeProvider>
    )
}

export default App
